var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-terms-detail"},[(_vm.content)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticClass:"empty"},[_vm._v("协议内容不存在")])])
}
var staticRenderFns = []

export { render, staticRenderFns }